import { render, staticRenderFns } from "./suivi.vue?vue&type=template&id=5cec466c"
import script from "./suivi.vue?vue&type=script&lang=js"
export * from "./suivi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports